import { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@airtm/airtm-ui';
import CustodialProviderSelector from 'components/CustodialProviderSelector/CustodialProviderSelector';
import ConnectToBridge from 'screens/SignUp/ProviderConnection/components/ConnectToBridge';
import { CUSTODIAL_PROVIDERS } from '@constants';
import LoginBackground from 'assets/images/login.jpg';
import DropBackground from 'assets/images/drop-background.png';

function ProviderConnection({ skip, showInSettings = false }) {
  const { t } = useTranslation('ENTERPRISE_SIGNUP');
  const [activeScreen, setActiveScreen] = useState('provider');
  const [custodialProviderSelected, setCustodialProviderSelected] = useState('');
  const onConnectWithProvider = (providerSelected) => {
    setCustodialProviderSelected(providerSelected);
    setActiveScreen('connection');
  };

  return (
    <div className="row no-gutters">
      {!showInSettings && (
        <div className="col-lg-6">
          <img className="img-login-signup" src={LoginBackground} alt="select-provider" />
        </div>
      )}
      <div className={cx('col-12', { 'col-lg-6': !showInSettings })}>
        {!showInSettings && (
          <div
            className="content-background content-background--size-contain"
            style={{ backgroundImage: `url(${DropBackground})` }}
          />
        )}
        <div
          className={cx({
            'col-12 col-sm-10 col-md-8 col-lg-8 offset-sm-1 offset-md-2 offset-lg-2':
              !showInSettings,
          })}
        >
          {activeScreen === 'provider' && (
            <div className={cx({ 'mt-9 mb-5': !showInSettings })}>
              {!showInSettings && <h1>{t('WELCOME_TITLE')}</h1>}
              <p
                className={cx(
                  'font-weight--regular',
                  { 'h5 mt-5 text--gray-5': !showInSettings },
                  { 'text--headings': showInSettings },
                )}
              >
                <Trans i18nKey="ENTERPRISE_SIGNUP:WELCOME_DESCRIPTION" />
              </p>
              <CustodialProviderSelector
                onConnect={onConnectWithProvider}
                showInSettings={showInSettings}
              />
              {!showInSettings && (
                <Button className="u-mt-4" onClick={skip}>
                  {t('SKIP_FOR_NOW')}
                </Button>
              )}
            </div>
          )}
          {activeScreen === 'connection' && (
            <>
              {showInSettings && (
                <>
                  <p className="font-weight--regular text--headings">
                    <Trans i18nKey="ENTERPRISE_SETTINGS:CUSTODIAL_SERVICE_DESCRIPTION" />
                  </p>
                  <p className="text--black font-weight--bold mb-0">
                    {t('ENTERPRISE_SETTINGS:CUSTODIAL_SERVICE_TITLE_DIVIDER')}
                  </p>
                </>
              )}
              {custodialProviderSelected === CUSTODIAL_PROVIDERS.BRIDGE && (
                <ConnectToBridge
                  onContinue={() => skip({ showEnable2FAScreen: false })}
                  onBack={() => setActiveScreen('provider')}
                  showInSettings={showInSettings}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

ProviderConnection.propTypes = {
  skip: PropTypes.func.isRequired,
  showInSettings: PropTypes.bool,
};

export default ProviderConnection;
